import React from 'react';

// Material-UI
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DownhillSkiingIcon from '@mui/icons-material/DownhillSkiing';
import Typography from '@mui/material/Typography';


// Responsive hooks
import { useResponsive } from '../../hooks/UseResponsive';

interface MaxRequestsWarningDialogProps {
  handleClose: () => void;
  show: boolean;
}

const MaxRequestsWarningDialog: React.FC<MaxRequestsWarningDialogProps> = (props) => {

  const { isMobile } = useResponsive();

  // #region Styles
  // #endregion

  return (
    <Dialog
      open={props.show}
      onClose={props.handleClose}
    >
      <DialogTitle>Maximum Weekend/Non-Holiday Requests <Chip icon={<DownhillSkiingIcon />} label="Weekend/Holiday" /></DialogTitle>
      <DialogContent>
        <Typography variant={isMobile ? 'body2' : 'body1'} paragraph>The maximuim priority requests have already been submitted.</Typography>
        <Typography variant={isMobile ? 'body2' : 'body1'}>Clear the form and select alternate dates.</Typography>
     </DialogContent>
      <DialogActions>
        <Button onClick={() => props.handleClose()} color="primary">Close</Button>
      </DialogActions>
    </Dialog>
  );

}

export default MaxRequestsWarningDialog;